exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".connection-loading-overlay {\n  position: fixed;\n  display: block;\n  width: 100%;\n  height: 100%;\n  top: 18px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  cursor: pointer;\n  background: #ffffffd9;\n}\n", ""]);

// exports
